import React from 'react';
import { VacationFieldset } from '@/features/Collaborators/Edit/Form/Fieldsets';
import { CollaboratorFormContext } from "@/features/Collaborators/Edit/Contexts/CollaboratorFormContext";

interface VacationTabProps {
    context: CollaboratorFormContext;
    collaboratorId?: string;
}

const VacationTab: React.FC<VacationTabProps> = ({ context, collaboratorId }) => {
    return (
        <div className="space-y-6">
            <VacationFieldset
                context={context}
                collaboratorId={collaboratorId}
            />
        </div>
    );
};

export default VacationTab;
